import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Invitation } from "../invitation.types";

/**
 * Read-only lookup of an invitation by shortcode.
 *
 * Deliberately does not emit invitation events — callers that need the
 * "invitation viewed" side effects use validateOrgInvitation instead. This
 * hook exists for routing decisions that must know the invitation type
 * before any of the invitation UI mounts.
 */
export function useInvitationByShortcode(shortcode?: string) {
  return useQuery<Invitation>({
    queryKey: ["invitation", "shortcode", shortcode],
    queryFn: () => apiRequest(`/invitation/${shortcode}/`, "GET", null, false),
    enabled: !!shortcode,
    retry: false,
  });
}

export default useInvitationByShortcode;
